const initialState = {
  orgId: '',
  orgKey: '',
  name: '',
  address: '',
  city: '',
  state: '',
  zip: '',
  phone: '',
  fax: '',
  cbpId: '',
};
export default initialState;
